module.exports = __webpack_public_path__ + "img/MTABAPPBP.fe8e4e99.svg";